import script from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SymbolPanel.vue?vue&type=style&index=0&id=2bb5f257&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb5f257"]])

export default __exports__